import { storage } from "./storageconstants";

/** sessionStorage values for SESSION_COMPLETED */
export const SessionCompletedStatus = {
  FALSE: "false",
  ALREADY_PAID: "already_paid",
  PAYMENT_FAILED: "payment_failed",
};

const SUCCESS_OUTCOME_SUFFIXES = [
  "/payment-success",
  "/direct-deposit-success",
];

const FAILURE_OUTCOME_SUFFIXES = [
  "/payment-failure",
  "/direct-deposit-insufficient-funds",
];

export function getSessionCompletedStatus() {
  const raw = sessionStorage.getItem(storage.SESSION_COMPLETED);
  // Migrate legacy boolean "true" from the earlier client guard.
  if (raw === "true") {
    return SessionCompletedStatus.ALREADY_PAID;
  }
  if (
    raw === SessionCompletedStatus.ALREADY_PAID ||
    raw === SessionCompletedStatus.PAYMENT_FAILED ||
    raw === SessionCompletedStatus.FALSE
  ) {
    return raw;
  }
  return SessionCompletedStatus.FALSE;
}

export function setSessionCompletedStatus(status) {
  sessionStorage.setItem(storage.SESSION_COMPLETED, status);
}

export function clearSessionCompleted() {
  setSessionCompletedStatus(SessionCompletedStatus.FALSE);
}

export function markAlreadyPaid() {
  setSessionCompletedStatus(SessionCompletedStatus.ALREADY_PAID);
}

export function markPaymentFailed() {
  setSessionCompletedStatus(SessionCompletedStatus.PAYMENT_FAILED);
}

export function isAlreadyPaidPath(pathname = window.location.pathname) {
  return normalizePathname(pathname).endsWith("/already-paid");
}

export function isSuccessOutcomePath(pathname = window.location.pathname) {
  const path = normalizePathname(pathname);
  return SUCCESS_OUTCOME_SUFFIXES.some((suffix) => path.endsWith(suffix));
}

export function isFailureOutcomePath(pathname = window.location.pathname) {
  const path = normalizePathname(pathname);
  return FAILURE_OUTCOME_SUFFIXES.some((suffix) => path.endsWith(suffix));
}

/** @deprecated Prefer isSuccessOutcomePath / isFailureOutcomePath */
export function isCheckoutOutcomePath(pathname = window.location.pathname) {
  return isSuccessOutcomePath(pathname) || isFailureOutcomePath(pathname);
}

/** Bare product entry: /{code} or /{code}/ — no step suffix. */
export function isProductEntryPath(pathname = window.location.pathname) {
  const segments = normalizePathname(pathname).split("/").filter(Boolean);
  return segments.length === 1;
}

/**
 * Client Back/restore guard:
 * - false → no-op
 * - already_paid → allow success / already-paid pages, otherwise redirect to /{code}/already-paid?session=…
 * - payment_failed → allow failure pages, otherwise redirect to /{code}
 * Returns true when redirecting.
 */
export function guardCompletedSession(pathname = window.location.pathname) {
  const status = getSessionCompletedStatus();
  if (status === SessionCompletedStatus.FALSE) {
    return false;
  }

  const code = sessionStorage.getItem(storage.CODE);
  if (!code) {
    return false;
  }

  if (status === SessionCompletedStatus.ALREADY_PAID) {
    if (isAlreadyPaidPath(pathname) || isSuccessOutcomePath(pathname)) {
      return false;
    }
    const sessionID = sessionStorage.getItem(storage.SESSION) || "";
    const query = sessionID ? `?session=${encodeURIComponent(sessionID)}` : "";
    window.location.replace(`/${code}/already-paid${query}`);
    return true;
  }

  if (status === SessionCompletedStatus.PAYMENT_FAILED) {
    if (isProductEntryPath(pathname) || isFailureOutcomePath(pathname)) {
      return false;
    }
    window.location.replace(`/${code}`);
    return true;
  }

  return false;
}

function normalizePathname(pathname) {
  if (!pathname || typeof pathname !== "string") {
    return "/";
  }
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}
